<template>
    <b-modal id="modal-sukses" title="Sukses" centered
        no-close-on-backdrop no-close-on-esc hide-header-close
        ok-only ok-title="OK" @ok="$emit('done')" auto-focus-button="ok"
    >
        Pembayaran telah sukses dilakukan. Silahkan melanjutkan proses ke kasir.
        <br /><br />
        No. Kwitansi:
        <h3 class="font-weight-bold">{{ noKwitansi }}</h3>
    </b-modal>
</template>

<script>
export default {
    name: 'modal-sukses',
    props: {
        noKwitansi: { type: String, required: true }
    }
}
</script>